import React from 'react';

import { Grid } from '@material-ui/core';

import ValueCard from './ValueCard.component';
import { EditorialValueCard } from '../../types/editorial-value-card.type';

type EditorialCardColumns = 2 | 3 | 4;

interface EditorialCardGridProps {
  cards: EditorialValueCard[];
  /** Nombre de cartes par rangée à partir de `md`. En dessous, deux puis une. */
  columns?: EditorialCardColumns;
}

// Une seule table de correspondance pour tout le site : les rangées de cartes des trois pages
// partagent ainsi le même espacement et le même comportement aux points de rupture.
const MEDIUM_SPAN: Record<EditorialCardColumns, 6 | 4 | 3> = {
  2: 6,
  3: 4,
  4: 3,
};

const EditorialCardGrid: React.FC<EditorialCardGridProps> = ({ cards, columns = 3 }) => (
  <Grid container spacing={3} alignItems="stretch">
    {cards.map((card) => (
      <Grid item xs={12} sm={6} md={MEDIUM_SPAN[columns]} key={card.lead}>
        <ValueCard card={card} />
      </Grid>
    ))}
  </Grid>
);

export default EditorialCardGrid;
